import { ICart } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/INewCartUnimarc'
import { Column, Picture } from '@smuchile/pkg-unimarc-components'
import {
  isValidArrayWithData,
  useFeatureFlag
} from '@smuchile/pkg-unimarc-hooks'
import { getBemId } from '@smuchile/pkg-unimarc-components/helpers'
import { AddressSelected } from 'components/AddressSelected'
import { getCategoryFromProducts } from 'shared/helpers'
import { ProductAccordion } from '../ProductAccordion'
import { FEATURES_FLAGS_IDENTIFIERS } from 'shared/utils/constants'

interface ProductsContainerProps {
  dataCart: ICart
  isLoadingByEvent: boolean
  isMobile: boolean
  openCollapse: boolean
  openCollapseIssues: boolean
  objetSrcImagesIconAddress: {
    imgByke: string
    imgStore: string
  }
  handleCollapse: (open: boolean) => void
  handleCollapseIssues: (open: boolean) => void
  setLimitOnProductAlert: (value: boolean) => void
}

export const ProductsContainer = ({
  dataCart,
  isLoadingByEvent,
  isMobile,
  openCollapse,
  openCollapseIssues,
  objetSrcImagesIconAddress,
  handleCollapse,
  handleCollapseIssues,
  setLimitOnProductAlert
}: ProductsContainerProps): React.ReactElement => {
  const hideWithTestFlag = useFeatureFlag(FEATURES_FLAGS_IDENTIFIERS.testFlag)
  const products =
    isValidArrayWithData(dataCart?.products) &&
    getCategoryFromProducts(dataCart)

  const allProducts = dataCart?.products?.find(({ categoryName }) => {
    return categoryName === 'Todos'
  }) ?? { totals: 0 }
  const totalQuantity = allProducts?.totals

  const totalProductsIssues = dataCart?.productsIssues?.[0]?.total ?? 0

  const sizeImage = isMobile ? '50px' : '80px'

  return (
    <>
      {dataCart?.address && (
        <>
          {!hideWithTestFlag ? (
            <AddressSelected
              isLoading={isLoadingByEvent}
              isMobile={isMobile}
              objetSrcImagesIconAddress={objetSrcImagesIconAddress}
              selectedAddress={dataCart?.address}
            />
          ) : null}
        </>
      )}
      <Column tagName='section'>
        {isValidArrayWithData(products?.items) && (
          <ProductAccordion
            dataCart={dataCart}
            handleCollapse={handleCollapse}
            headTitle='Mis productos 🥑'
            isLoadingByEvent={isLoadingByEvent}
            itemsAmount={products?.items?.length}
            openCollapse={openCollapse}
            setLimitOnProductAlert={setLimitOnProductAlert}
            totalQuantity={totalQuantity}
          >
            {products?.items.map((item, index) => {
              return (
                <Picture
                  alt={item?.description?.name}
                  height={sizeImage}
                  id={getBemId('product', 'image', index.toString())}
                  key={item?.description?.id}
                  objectFit='contain'
                  src={item?.description?.image}
                  width={sizeImage}
                />
              )
            })}
          </ProductAccordion>
        )}

        {isValidArrayWithData(dataCart?.productsIssues?.[0]?.itemsIssues) && (
          <ProductAccordion
            dataCart={dataCart}
            handleCollapse={handleCollapseIssues}
            headTitle='No disponibles 🌶️'
            isLoadingByEvent={isLoadingByEvent}
            isProductsWithIssues={true}
            itemsAmount={dataCart?.productsIssues?.[0]?.itemsIssues?.length}
            openCollapse={openCollapseIssues}
            setLimitOnProductAlert={setLimitOnProductAlert}
            totalQuantity={totalProductsIssues}
          >
            {dataCart?.productsIssues?.[0]?.itemsIssues.map(
              (product, index) => {
                return (
                  <Picture
                    alt={product?.orderItem?.name}
                    height={sizeImage}
                    id={getBemId('productIssue', 'image', index.toString())}
                    key={product?.orderItem?.id}
                    objectFit='contain'
                    src={product?.orderItem?.image}
                    style={{
                      opacity: 0.5
                    }}
                    width={sizeImage}
                  />
                )
              }
            )}
          </ProductAccordion>
        )}
      </Column>
    </>
  )
}
